module.exports = __webpack_public_path__ + "img/noimage.f2b6eafb.png";